export const cadastreLandFields = [
  {
    name: 'section_code',
    type: 'string',
    required: false,
    size: 'ms-sm2',
  },
  {
    name: 'map_sheet_number',
    type: 'string',
    required: true,
    size: 'ms-sm2',
  },
  {
    name: 'parcel_number',
    type: 'string',
    required: true,
    size: 'ms-sm3',
  },
  {
    name: 'type',
    type: 'string',
    required: true,
    size: 'ms-sm3',
  },
  {
    name: 'class_of_prodctivity',
    type: 'string',
    required: true,
    size: 'ms-sm2',
  },
  {
    name: 'consistency_ha',
    type: 'number',
    required: true,
    suffix: 'ha',
    size: 'ms-sm4',
  },
  {
    name: 'consistency_a',
    type: 'number',
    required: true,
    suffix: 'a',
    size: 'ms-sm4',
  },
  {
    name: 'consistency_ca',
    type: 'number',
    required: true,
    suffix: 'ca',
    size: 'ms-sm4',
  },
  {
    name: 'income_landlord',
    type: 'currency',
    required: true,
    size: 'ms-sm6',
  },
  {
    name: 'income_agrarian',
    type: 'currency',
    required: true,
    size: 'ms-sm6',
  },
  {
    name: 'cadastral_municipality',
    type: 'string',
    required: false,
    size: 'ms-sm4',
  },
  {
    name: 'address',
    type: 'string',
    required: false,
    size: 'ms-sm8',
  },
];

export const cadastreLandProps = () => {
  const result = {};

  cadastreLandFields.forEach((field) => {
    result[field.name] = field.type === 'string' ? '' : 0;
  });

  return result;
};



// WEBPACK FOOTER //
// ./src/app/@propnow/containers/Sale/SaleEditSection/_it/cadastreFields/cadastreLandFields.js